import {Component, OnInit} from '@angular/core';
import {DynamicDialogConfig, DynamicDialogRef} from "primeng/dynamicdialog";
import {MessageService, SelectItem} from "primeng/api";
import { TooltipModule } from 'primeng/tooltip';
import {TranslatePipe, TranslateService} from "@ngx-translate/core";
import {PropertyModel} from "../../models/property-model";
import {PropertyService} from "../../../shared/forms/services/property.service";
//import {ToastrModule, ToastrService} from "ngx-toastr";
import {EditableRow, TableModule} from "primeng/table";
import {FormsModule} from "@angular/forms";
import {DropdownModule} from "primeng/dropdown";
import {Button, ButtonDirective} from "primeng/button";
import {Ripple} from "primeng/ripple";
import {InputTextModule} from "primeng/inputtext";
import {CommonModule} from "@angular/common";

interface Column {
    field: string;
    header: string;
}

@Component({
    selector: 'app-property-form',
    templateUrl: './property-form.component.html',
    styleUrls: ['./property-form.component.scss'],
    providers: [MessageService, PropertyService, EditableRow],
    imports: [
        CommonModule,
        TableModule,
        FormsModule,
        DropdownModule,
        ButtonDirective,
        Ripple,
        Button,
        TranslatePipe,
        InputTextModule,
        TooltipModule
    ],
    standalone: true
})
export class PropertyFormComponent implements OnInit {

    propertyLabel: string | null = null;
    propertyKey: string | null = null;
    header: any;
    propertyModelList: PropertyModel[] = [];


    cols: Column[]  = [
        { field: 'de', header: 'DE' },
        { field: 'tr', header: 'TR' },
    ];
    clonedPropertyModelList: { [s: string]: PropertyModel; } = {};

    languages: SelectItem[] = [];
    expandedRows: { [key: number]: boolean } = {};

    constructor(public ref: DynamicDialogRef,
                public config: DynamicDialogConfig,
                private propertyService: PropertyService,
                private messageService: MessageService,
                private translate: TranslateService) {
    }

    ngOnInit() {
        this.propertyLabel = this.config.data['propertyLabel'];


        this.header = this.translate.instant(`properties.${this.config.data.propertyKey}`);
        this.propertyKey = this.config.data['propertyKey'];

        if (this.propertyKey) {
            this.propertyService.getPropertiesByKey(this.propertyKey).then(value => {
                this.propertyModelList = value ?? [];
            });
        }



        this.languages = [
            {label: 'Deutsch', value: 'de'},
            {label: 'Englisch', value: 'en'}
        ];
    }

    onRowToggle(event: any): void {
        this.expandedRows = event.data; // Updates expanded rows state
    }

    onRowEditInit(property: PropertyModel) {
        this.clonedPropertyModelList[property.id] = {...property};
    }

    onRowEditSave(property: PropertyModel) {
        // Add save logic here if needed
    }

    onRowEditCancel(property: PropertyModel, index: number) {
        if (property.id && this.clonedPropertyModelList[property.id]) {
            this.propertyModelList[index] = this.clonedPropertyModelList[property.id];
            delete this.clonedPropertyModelList[property.id];
        }
    }

    addNewProperty() {
        this.propertyModelList.push({
            id: "",
            dtype: this.propertyKey ?? null,
            dtext: "",
            dkey: "",
            weighting: 0,
            order: 0,
            languageWertMap: {
                de: '',
                tr: ''
            },
        });
    }

    saveProperties() {
        const saveNext = () => {
            if (this.propertyModelList.length > 0) {
                const property = this.propertyModelList.pop();
                if (property) {
                    this.propertyService.postProperties(property).subscribe({
                        next: () => saveNext(),
                        error: (err: any) => console.error(err)
                    });
                }
            } else {
                // this.toastr.success(
                //     this.translate.instant('sp-preferences'),
                //     this.translate.instant('sp-preferences-saved'),
                //     {positionClass: 'sign-process-state-bottom-right'}
                // );
                this.ref.close(true);
            }
        };
        saveNext();
    }


    onRowReorder(reorder: any) {
        const item = reorder.dragIndex;
        const position = reorder.dropIndex;

        const start = Math.min(item, position);
        for (let i = start; i < this.propertyModelList.length; i++) {
            this.propertyModelList[i].order = i;
        }
    }


}
